export default __webpack_public_path__ + "static/media/repair-plus.ef4aa71d.png";